import { render, staticRenderFns } from "./RootCol.vue?vue&type=template&id=4af0e690&scoped=true&"
import script from "./RootCol.vue?vue&type=script&lang=ts&"
export * from "./RootCol.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af0e690",
  null
  
)

export default component.exports